<template>
  <default-layout>
    <section>
      <Listing />
    </section>
  </default-layout>
  <MoyasarPayment/>
</template>

<script>
import DefaultLayout from "@/components/layouts/DefaultLayout.vue";
import Listing from "@/components/listings/index.vue";
import MoyasarPayment from "@/components/moyasar/gateway.vue"

export default {
  name: "AparmentView",
  components: {
    DefaultLayout,
    Listing,
    MoyasarPayment
  },
};
</script>
<style scoped>
.desktop-header {
  display: block;
  min-height: 80px;
}
.mobile-header {
  display: none;
}
@media (max-width: 700px) and (min-width: 320px) {
  .desktop-header {
    display: none;
  }
  .mobile-header {
    display: block;
  }
}
</style>
